import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  saveCategory,
  updateCategory,
} from "../../../redux/slices/categorySlice";
import { StyledButton } from "../../CSS/Styles";

const Categories = () => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.categories.categories);

  const [openForm, setOpenForm] = useState(false);
  const [newCategory, setNewCategory] = useState({
    name: "",
    description: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    if (!newCategory.name) tempErrors.name = "Name is required.";
    if (!newCategory.description)
      tempErrors.description = "Description is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenForm = () => {
    setOpenForm(true);
    setEditMode(false);
    setNewCategory({ name: "", description: "" });
    setErrors({});
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setNewCategory({ name: "", description: "" });
    setErrors({});
  };

  const handleSaveCategory = () => {
    if (validate()) {
      if (editMode) {
        dispatch(updateCategory(newCategory));
      } else {
        dispatch(saveCategory(newCategory));
      }
      handleCloseForm();
    }
  };

  const handleEdit = (category) => {
    setNewCategory(category);
    setOpenForm(true);
    setEditMode(true);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Box display="flex" justifyContent="flex-start">
          {!openForm && (
            <StyledButton
              sx={{
                marginBottom: 2,
                fontSize: "14px",
                padding: "8px 16px",
              }}
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleOpenForm}
            >
              Add Category
            </StyledButton>
          )}
        </Box>

        {!openForm ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categories?.map((category) => (
                  <TableRow key={category.id}>
                    <TableCell>{category.en.name}</TableCell>
                    <TableCell>{category.en.description}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => handleEdit(category.en)}
                        color="primary"
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={handleCloseForm}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">
                {editMode ? "Edit Category" : "Add New Category"}
              </Typography>
            </Box>
            <TextField
              label="Name"
              name="name"
              value={newCategory.name}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              error={!!errors.name}
              helperText={errors.name}
            />
            <TextField
              label="Description"
              name="description"
              value={newCategory.description}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
              error={!!errors.description}
              helperText={errors.description}
            />
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleCloseForm}
                sx={{ marginRight: 2 }}
                color="error"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveCategory}
                color="primary"
                variant="contained"
              >
                Save
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Categories;
